<template>
  <div class="guide">
    <div v-if="guidanceList.length > 0">
      <div class="part" v-for="(item, index) in guidanceList" :key="index">
        <div class="part_title" v-if="item.news_type === 1">
          <span>{{ $t("遊戲地圖") }}</span>
        </div>
        <div class="part_title" v-if="item.news_type === 2">
          <span>{{ $t("新手指南") }}</span>
        </div>
        <div class="part_title" v-if="item.news_type === 3">
          <span>{{ $t("裝備技能") }}</span>
        </div>
        <div class="part_title" v-if="item.news_type === 4">
          <span>{{ $t("進階攻略") }}</span>
        </div>
        <div
          class="part_category"
          v-for="(it, ind) in item.children"
          :key="ind"
        >
          <div class="tag">{{ it.news_sub_type }}</div>
          <div class="category_box">
            <div
              class="category"
              v-for="(i, n) in it.child"
              :key="n"
              @click="detail(i)"
            >
              {{ i.article.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Nodata v-else />
  </div>
</template>
<script>
import { getImformationList } from "@/api/imformation";
export default {
  data() {
    return {
      guidanceList: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    detail(item) {
      this.$router.push(`/imformationDetail?id=${item.id}`);
    },
    async getData() {
      const res = await getImformationList({ limit: 999999 });
      this.guidanceList = [];
      let result = res.data.results.map((item) => item.news_type);
      let allType = [...new Set(result)];
      let subResult = res.data.results.map((item) => item.news_sub_type);
      let allSubType = [...new Set(subResult)];
      allType.map((i) => {
        let data = res.data.results.filter((it) => it.news_type === i);
        let arr = [];
        allSubType.map((item) => {
          let fin = data.filter((it) => it.news_sub_type === item);
          if (fin.length > 0) {
            let subItem = {
              news_sub_type: item,
              child: fin,
            };
            arr.push(subItem);
          }
        });
        let single = {
          news_type: i,
          children: arr,
        };
        this.guidanceList.push(single);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.guide {
  margin-bottom: 40px;
  @media only screen and (max-width: 900px) {
    margin-bottom: 20px;
  }
  div {
    .part {
      .part_title {
        color: #c6a86c;
        font-size: 18px;
        padding-bottom: 22px;
        border-bottom: 1px solid rgba($color: #cecece, $alpha: 0.4);
        text-align: left;
        position: relative;
        margin-bottom: 45px;
        @media only screen and (max-width: 900px) {
          padding-bottom: 11px;
          font-size: 14px;
          border-bottom: 1px solid rgba($color: #cecece, $alpha: 0.4);
          margin-bottom: 20px;
        }
        &::after {
          width: 110px;
          height: 3px;
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: -1px;
          background: #c6a86c;
          @media only screen and (max-width: 900px) {
            bottom: -1px;
            width: 30%;
            height: 3px;
          }
        }
        span {
          width: fit-content;
          text-align: center;
          display: block;
          @media only screen and (max-width: 900px) {
            width: 30%;
            text-align: center;
            display: block;
          }
        }
      }
      .part_category {
        display: flex;
        align-items: flex-start;
        width: 100%;
        margin-bottom: 36px;
        @media only screen and (max-width: 900px) {
          width: 100%;
          margin-bottom: 36px;
        }
        .tag {
          min-width: 110px;
          height: 30px;
          line-height: 30px;
          background-color: #c6a86c;
          font-size: 16px;
          color: #fff;
          @media only screen and (max-width: 900px) {
            min-width: 90px;
            font-size: 14px;
            height: 30px;
            line-height: 30px;
          }
        }
        .category_box {
          display: flex;
          align-items: flex-start;
          flex-wrap: wrap;

          .category {
            padding: 0 15px;
            font-size: 16px;
            color: #676a6d;
            line-height: 30px;
            height: 30px;
            margin-bottom: 36px;
            position: relative;
            cursor: pointer;
            @media only screen and (max-width: 900px) {
              font-size: 14px;
              line-height: 30px;
              height: 30px;
              margin-bottom: 18px;
              padding: 0 7px;
            }
            &::after {
              position: absolute;
              content: "";
              top: 50%;
              right: 0;
              height: 19px;
              width: 1px;
              background-color: #676a6d;
              margin-top: -10px;
              @media only screen and (max-width: 900px) {
                margin-top: -10px;
                top: 50%;
                right: 0;
                height: 19px;
                width: 1px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
